<style src="./ParkingMap.scss" lang="scss"></style>
<template>
  <div>
    <GmapMap
      class="mapcontainer"
      :center="center"
      :zoom="15"
      :options="mapOptions"
    >
      <GmapInfoWindow
        ref="windowRef"
        :position="infoWindowPos"
        :opened="infoWinOpen"
        :options="infoOptions"
        @closeclick="infoWinOpen = false"
      >
        <div class="infowindowcontent">
          <h5>{{ parkName }}</h5>
          <h4>Quantidade de vagas: {{ parkingSpaceCount }}</h4>
        </div>
      </GmapInfoWindow>
      <GmapMarker
        :key="index"
        v-for="(m, index) in markers"
        :position="m.position"
        :clickable="true"
        :draggable="false"
        @click="toggleInfoWindow(m, index)"
      >
      </GmapMarker>
    </GmapMap>
  </div>
</template>

<script>
export default {
  name: "ParkingMap",
  data: () => ({
    center: { lat: -22.36416, lng: -42.3133184 },
    markers: [],
    mapStyles: [
      {
        featureType: "poi",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
    ],
    infoWindowPos: null,
    infoWinOpen: false,
    currentMidx: null,
    windowRef: null,
    parkingSpaceCount: 0,
    parkName: "",
    infoOptions: {
      //optional: offset infowindow so it visually sits nicely on top of our marker
      pixelOffset: {
        width: 0,
        height: -35,
      },
    },
  }),
  async mounted() {
    await this.$gmapApiPromiseLazy();
    this.loadMarkers();
  },
  computed: {
    mapOptions() {
      return {
        styles: this.mapStyles,
      };
    },
  },
  methods: {
    toggleInfoWindow: function(marker, idx) {
      this.infoWindowPos = marker.position;
      this.parkingSpaceCount = marker.parkingSpaceCount;
      this.parkName = marker.parkName;

      //check if its the same marker that was selected if yes toggle
      if (this.currentMidx == idx) {
        this.infoWinOpen = !this.infoWinOpen;
      }

      //if different marker set infowindow to open and reset current marker index
      else {
        this.infoWinOpen = true;
        this.currentMidx = idx;
      }
    },

    async loadMarkers() {
      const parkings = await this.$store.dispatch("PARKING/GetParkList");
      const formattedParking = parkings.map((parking) => {
        return {
          position: {
            lat: parking.pathPolygon.coordinates[0],
            lng: parking.pathPolygon.coordinates[1],
          },
          parkingSpaceCount: parking.parkingSpaceCount,
          parkName: parking.parkName,
        };
      });
      this.markers = formattedParking;
    },
  },
};
</script>
